/**
 * Converte valor monetário em reais para extenso (pt-BR).
 * Ex.: 7285.70 → "sete mil e duzentos e oitenta e cinco reais e setenta centavos"
 */
export function valorPorExtenso(value: number): string {
  const n = Math.round((Number(value) || 0) * 100) / 100;
  if (n === 0) return 'zero reais';

  const inteiro = Math.floor(n);
  const centavos = Math.round((n - inteiro) * 100);

  const partes: string[] = [];
  if (inteiro > 0) {
    partes.push(`${numeroPorExtenso(inteiro)} ${inteiro === 1 ? 'real' : 'reais'}`);
  }
  if (centavos > 0) {
    if (partes.length) partes.push('e');
    partes.push(`${numeroPorExtenso(centavos)} ${centavos === 1 ? 'centavo' : 'centavos'}`);
  }

  return partes.join(' ');
}

function numeroPorExtenso(n: number): string {
  if (n < 0) return '';
  if (n === 0) return 'zero';

  const unidades = [
    '', 'um', 'dois', 'três', 'quatro', 'cinco', 'seis', 'sete', 'oito', 'nove',
    'dez', 'onze', 'doze', 'treze', 'quatorze', 'quinze', 'dezesseis', 'dezessete', 'dezoito', 'dezenove'
  ];
  const dezenas = ['', '', 'vinte', 'trinta', 'quarenta', 'cinquenta', 'sessenta', 'setenta', 'oitenta', 'noventa'];
  const centenas = [
    '', 'cento', 'duzentos', 'trezentos', 'quatrocentos', 'quinhentos',
    'seiscentos', 'setecentos', 'oitocentos', 'novecentos'
  ];

  if (n < 20) return unidades[n];
  if (n < 100) {
    const d = Math.floor(n / 10);
    const u = n % 10;
    return u ? `${dezenas[d]} e ${unidades[u]}` : dezenas[d];
  }
  if (n === 100) return 'cem';
  if (n < 1000) {
    const c = Math.floor(n / 100);
    const r = n % 100;
    return r ? `${centenas[c]} e ${numeroPorExtenso(r)}` : centenas[c];
  }
  if (n < 1_000_000) {
    const mil = Math.floor(n / 1000);
    const r = n % 1000;
    const milTxt = mil === 1 ? 'mil' : `${numeroPorExtenso(mil)} mil`;
    if (!r) return milTxt;
    const conjuncao = r < 100 || r % 100 === 0 ? ' e ' : ' ';
    return `${milTxt}${conjuncao}${numeroPorExtenso(r)}`;
  }

  const milhao = Math.floor(n / 1_000_000);
  const r = n % 1_000_000;
  const milhaoTxt = milhao === 1 ? 'um milhão' : `${numeroPorExtenso(milhao)} milhões`;
  if (!r) return milhaoTxt;
  return `${milhaoTxt} e ${numeroPorExtenso(r)}`;
}
